// extracted by mini-css-extract-plugin
module.exports = {"cp-ticket-btn":"styles_cp-ticket-btn__1kHpO"};